import { uploadOriginalTicket } from "app/services/AdminServices/bookingService";
import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

const UploadOriginalTicket = ({
  show,
  handleClose,
  row,
  loadBookingDetails,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleDiscard = () => {
    setSelectedFile(null);
    setPreviewUrl("");
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("BookingId", row.id);
    formData.append("TicketFile", selectedFile);
    formData.append("TicketName", selectedFile.name);
    formData.append("TicketFilePath", "");

    try {
      const res = await uploadOriginalTicket(formData);
      //   console.log("Upload success:", res);
      if (res.data.status == "Success") {
        NotificationManager.success(res.data.message);
      } else {
        NotificationManager.success(res.data.message);
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      handleClose();
      handleDiscard();
      loadBookingDetails();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="align-items-end">
          <Col md={11}>
            <Form.Group>
              <Form.Label>Please select a PDF document</Form.Label>
              <Form.Control
                type="file"
                accept=".pdf,application/pdf"
                onChange={handleFileChange}
              />
            </Form.Group>
          </Col>

          <Col md={1}>
            <Button
              variant="danger"
              onClick={handleDiscard}
              className="w-100 text-white"
              disabled={!previewUrl}
            >
              X
            </Button>
          </Col>
        </Row>
        {previewUrl ? (
          <div
            className="mt-3 border rounded d-flex justify-content-center align-items-center"
            style={{
              height: "300px",
              overflow: "hidden",
              background: "#f8f9fa",
            }}
          >
            {/* {selectedFile?.type.startsWith("image/") ? (
              <img
                src={previewUrl}
                alt="preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            ) : ( */}
            <iframe
              src={previewUrl}
              title="pdf-preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
            {/* )} */}
          </div>
        ) : (
          <div
            className="mt-3 border rounded d-flex justify-content-center align-items-center"
            style={{
              height: "200px",
              overflow: "hidden",
              background: "#f8f9fa",
            }}
          >
            <div>Upload Preview</div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Upload
        </Button>
        <Button variant="primary" onClick={handleUpload}>
          Upload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadOriginalTicket;
